import { withRouter } from "../../components/withRouter";
import { withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { withToast } from "../../App";
import CustomComponent from "../../components/customComponent";
import { DefaultLayout } from "../../components/Layouts";
import { FormAutoComplete } from "../../components/FormComponents";
import LoadingOverlay from "../../components/LoadingOverlay";

class RestartTerminal extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            distribution: {
                terminal: "",
            },
            formIsValid: false,
            terminal: "",
            terminals: [],
            terminalSuggestions: [],
            isLoading: false,
        };
        this._isMounted = false;
        this.timeout = null;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.timeout) clearTimeout(this.timeout);
    }

    checkFormValidity() {
        const isValid = this.state.distribution.terminal !== "";

        this.setState({ formIsValid: isValid });
    }

    async onSubmit(e) {
        const { t } = this.props;
        e.preventDefault();
        let url = `/terminal/reset/${this.state.distribution.terminal}`;
        let method = "POST";
        let csrf = await this.getCsrfToken("/terminal/csrf");
        let body = JSON.stringify({
            chargeBoxId: this.state.distribution.terminal,
            resetType: "SOFT",
            _csrf_token: csrf,
        });

        this.setState({ isLoading: true });
        let data = await this.request(url, method, body);

        if (data && data.status === "ok") {
            this.props.addToast(t("terminal_reset_success"), {
                appearance: "success",
                autoDismiss: true,
                autoDismissTimeout: 4000,
            });
        }
        this.setState({ isLoading: false });
    }

    handleTerminalChange = (e) => {
        const { value } = e.target;
        const { id } = e.target.dataset;
        this._isMounted &&
            this.setState(
                (prevState) => ({
                    terminal: value,
                    distribution: {
                        ...prevState.distribution,
                        terminal: id,
                    },
                }),
                () => this.checkFormValidity(),
            );
    };

    handleTerminalSuggestions = async (e) => {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
            const { value } = e.target;
            let url = `/terminal/?q=${value}`;
            const method = "GET";

            let data = await this.request(url, method);

            if (data && data.terminals) {
                const filteredTerminals = data.terminals;

                this._isMounted &&
                    this.setState({
                        terminals: filteredTerminals,
                        terminalSuggestions: filteredTerminals.map((t) => ({
                            id: t.id,
                            name: t.cpoTerminalId,
                        })),
                    });
            }
        }, 200);
    };

    render() {
        const { t } = this.props;

        return (
            <DefaultLayout>
                <LoadingOverlay
                    active={this.state.isLoading}
                    spinner
                    text={t("loading")}
                />
                <h1 className="main-title">{t("remote_operations")}</h1>
                <div className="primary-form">
                    <form onSubmit={(e) => this.onSubmit(e)}>
                        <h2 className="primary-form__title">
                            {t("restart_a_terminal")}
                        </h2>
                        <hr className="form-divider form-divider--big" />
                        <div className="row">
                            <div className="col-12">
                                <FormAutoComplete
                                    required
                                    label={t("terminal")}
                                    placeholder={t(
                                        "filter_terminal_placeholder",
                                    )}
                                    id="terminal"
                                    name="terminal"
                                    value={this.state.terminal}
                                    onFieldChange={
                                        this.handleTerminalSuggestions
                                    }
                                    handle={this.handleTerminalChange}
                                    suggestions={this.state.terminalSuggestions}
                                />
                            </div>
                        </div>
                        <div className="primary-form__buttons primary-form__buttons--right">
                            <button
                                type="submit"
                                disabled={!this.state.formIsValid}
                                className="vnf-btn vnf-btn-primary vnf-btn-m vnf-btn-similar-color vnf-btn-bleu-a2 vnf-btn-box-shadow-bleu-a4"
                            >
                                {t("send")}
                            </button>
                        </div>
                        <p className="primary-form__required-fields">
                            * {t("required_fields")}
                        </p>
                    </form>
                </div>
            </DefaultLayout>
        );
    }
}

export default withToast(
    hoistStatics(
        withTranslation()(withRouter(RestartTerminal)),
        RestartTerminal,
    ),
);
